import { useEffect } from 'react'
import { LeftSection, RightSection, SavingsHeader, SavingsWrapper } from '../savingsStage/SavingsStage.styles'

export const SavingPlanPin = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <SavingsWrapper>
    <SavingsHeader>
          <LeftSection>
          <h3 className='savingPlan'>
                 This is otherwise known as the Savings plan PIN (SP PIN) with these 6 unique PIN,  you get to activate your desired savings plan.      
          </h3>
          </LeftSection>
          <RightSection>
              <img src="img/Group 8618.svg" alt="couple saving in a bottle" />
          </RightSection>
      </SavingsHeader>
      </SavingsWrapper>
  )
}